var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2377_187",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 0H0.5V25H21.5V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2377_187)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2377_187",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 25
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 0.5H0.5V24.5H21.5V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2377_187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5377 5.38538L15.9223 0.77C15.8365 0.684307 15.7347 0.616356 15.6226 0.570028C15.5106 0.523701 15.3905 0.499905 15.2692 0.5H6.03846C5.54883 0.5 5.07926 0.694505 4.73303 1.04073C4.38681 1.38695 4.19231 1.85652 4.19231 2.34615V4.19231H2.34615C1.85652 4.19231 1.38695 4.38681 1.04073 4.73303C0.694505 5.07926 0.5 5.54883 0.5 6.03846V22.6538C0.5 23.1435 0.694505 23.6131 1.04073 23.9593C1.38695 24.3055 1.85652 24.5 2.34615 24.5H15.2692C15.7589 24.5 16.2284 24.3055 16.5747 23.9593C16.9209 23.6131 17.1154 23.1435 17.1154 22.6538V20.8077H18.9615C19.4512 20.8077 19.9207 20.6132 20.267 20.267C20.6132 19.9207 20.8077 19.4512 20.8077 18.9615V6.03846C20.8078 5.91721 20.784 5.79712 20.7377 5.68506C20.6913 5.57301 20.6234 5.47117 20.5377 5.38538ZM15.2692 22.6538H2.34615V6.03846H11.195L15.2692 10.1127V19.9031V22.6538ZM18.9615 18.9615H17.1154V9.73077C17.1155 9.60951 17.0917 9.48943 17.0454 9.37737C16.999 9.26531 16.9311 9.16348 16.8454 9.07769L12.23 4.46231C12.1442 4.37661 12.0424 4.30866 11.9303 4.26234C11.8183 4.21601 11.6982 4.19221 11.5769 4.19231H6.03846V2.34615H14.8873L18.9615 6.42038V18.9615ZM12.5 15.2692C12.5 15.514 12.4027 15.7488 12.2296 15.9219C12.0565 16.0951 11.8217 16.1923 11.5769 16.1923H6.03846C5.79365 16.1923 5.55886 16.0951 5.38575 15.9219C5.21264 15.7488 5.11539 15.514 5.11539 15.2692C5.11539 15.0244 5.21264 14.7896 5.38575 14.6165C5.55886 14.4434 5.79365 14.3462 6.03846 14.3462H11.5769C11.8217 14.3462 12.0565 14.4434 12.2296 14.6165C12.4027 14.7896 12.5 15.0244 12.5 15.2692ZM12.5 18.9615C12.5 19.2064 12.4027 19.4411 12.2296 19.6143C12.0565 19.7874 11.8217 19.8846 11.5769 19.8846H6.03846C5.79365 19.8846 5.55886 19.7874 5.38575 19.6143C5.21264 19.4411 5.11539 19.2064 5.11539 18.9615C5.11539 18.7167 5.21264 18.4819 5.38575 18.3088C5.55886 18.1357 5.79365 18.0385 6.03846 18.0385H11.5769C11.8217 18.0385 12.0565 18.1357 12.2296 18.3088C12.4027 18.4819 12.5 18.7167 12.5 18.9615Z",
    fill: "#2B2B67"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.51225c06eadaedbd000af3587f6ce2d3.svg";
export { ForwardRef as ReactComponent };